import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'sentry-button-cell-renderer',
    templateUrl: './button-cell-renderer.component.html',
    styleUrls: ['./button-cell-renderer.component.scss'],
    standalone: true,
    imports: [MatButtonModule, MatProgressSpinnerModule]
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private params: any;

  hasClicked = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  agInit(params: any): void {
    this.params = params;
  }

  btnClickedHandler() {
    this.hasClicked = true;
    this.params.clicked(this.params);
  }
}
